<template>
	<div class="row">
		<div v-if="!products.length" class="col">
			{{ $tr.product.filter.empty }}
		</div>
		<div v-else v-for="item in products" :class="classes">
			<ProductOption
                :item="item"
                :showFabric="showFabric"
                :overlay="overlay"
                :product-id="productId"
                @openSidebar="$emit('openSidebar')"
				:key="productId + item.id"
				:multiple="product.multiple"
            />
		</div>
	</div>
</template>

<script>
	import ProductOption from "./ProductSelect/ProductOption";

	export default {
		name: "ProductSelect",
		components: {
			ProductOption,
		},
		props: [
			"products",
			"product",
			"productId",
			"classes",
			"overlay",
			"showFabric"
		]
	}
</script>
